<template>
  <v-card class="premium-dialog-card" style="width: 100%">
    <overlay-loading-progress :LoadingFlag="LoadingFlag" />

    <!-- Premium Dialog Header -->
    <div class="premium-dialog-header">
      <div class="header-content">
        <v-icon large color="white" class="mr-3"
          >mdi-alert-circle-outline</v-icon
        >
        <div class="header-text-container">
          <h2 class="premium-dialog-title">Mark as Not Eligible</h2>
          <p class="premium-dialog-subtitle">
            Update the eligibility status of selected scholarship applicants
          </p>
        </div>
      </div>
      <v-btn icon dark class="close-btn" @click="closePrompt">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <!-- Premium Dialog Content -->
    <v-card-text class="premium-dialog-content">
      <v-row>
        <!-- Left Column: Selected Students List -->
        <v-col cols="12" md="5" class="d-flex flex-column">
          <div class="premium-section-card flex-grow-1">
            <div class="section-heading-wrapper">
              <v-icon color="#56BDA3" class="mr-2"
                >mdi-account-multiple-remove-outline</v-icon
              >
              <h3 class="section-title">
                Selected Applicants ({{ studentsList.length }})
              </h3>
            </div>

            <div class="student-scroll-list">
              <div
                v-for="(student, index) in studentsList"
                :key="student.StudentId || index"
                class="student-list-item"
              >
                <div class="student-item-icon">
                  <v-icon color="#3A67B1" size="18">mdi-account-outline</v-icon>
                </div>
                <div class="student-item-info">
                  <span class="student-name">{{
                    student.StudentName || "Unknown Student"
                  }}</span>
                  <span class="student-meta">
                    <span class="meta-label">App No:</span>
                    <span class="meta-value">{{
                      student.ApplicationNumber || "N/A"
                    }}</span>
                  </span>
                </div>
              </div>
              <div v-if="studentsList.length === 0" class="no-students-message">
                <v-icon size="32" color="#414042" style="opacity: 0.5"
                  >mdi-account-off-outline</v-icon
                >
                <p
                  class="mt-2 text-subtitle-2"
                  style="color: #414042; opacity: 0.7"
                >
                  No applicants selected
                </p>
              </div>
            </div>
          </div>
        </v-col>

        <!-- Right Column: Status Update Form -->
        <v-col cols="12" md="7">
          <!-- Premium Alert Warning Box -->
          <div class="premium-alert-banner mb-4">
            <v-icon color="#EDBE38" class="mr-3">mdi-alert-box-outline</v-icon>
            <div class="alert-banner-text">
              <strong>Important Action:</strong> You are changing the status of
              selected students to <strong>Not Eligible</strong>. A
              justification description is required.
            </div>
          </div>

          <!-- Input Description Block -->
          <div class="premium-section-card">
            <div class="section-heading-wrapper">
              <v-icon color="#3A67B1" class="mr-2"
                >mdi-pencil-box-outline</v-icon
              >
              <h3 class="section-title required-field">Description</h3>
            </div>
            <div class="mt-4">
              <v-textarea
                outlined
                v-model="Description"
                :rules="DescriptionRules"
                name="ineligibility-description"
                placeholder="Provide a detailed reason why the applicant(s) are not eligible..."
                class="premium-textarea"
                rows="4"
                no-resize
              ></v-textarea>
            </div>
          </div>

          <!-- Action Footer -->
          <div class="premium-dialog-footer mt-4">
            <div class="action-buttons-container">
              <v-btn
                @click="submitForm"
                :disabled="Description === '' || LoadingFlag"
                :loading="LoadingFlag"
                class="action-btn btn-not-eligible"
              >
                <v-icon left>mdi-alert-circle-outline</v-icon>
                Mark Not Eligible
              </v-btn>
              <v-btn @click="closePrompt" class="action-btn btn-cancel">
                <v-icon left>mdi-close</v-icon>
                Cancel
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  props: {
    recordData: {
      required: true,
      type: [Object, Array],
    },
  },
  data() {
    return {
      Description: "",
      DescriptionRules: [(v) => !!v || "Description is required"],

      LoadingFlag: false,
      ResultFlag: false,
    };
  },
  computed: {
    studentsList() {
      if (!this.recordData) return [];
      if (Array.isArray(this.recordData)) return this.recordData;
      return [this.recordData];
    },
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      this.pageData();
    },
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideNotEligibleRecordPrompt", this.ResultFlag);
    },
    pageData() {
      console.log("pageData called");
    },
    submitForm() {
      console.log("submitForm called");

      console.log({ recordData: this.recordData });

      this.LoadingFlag = true;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/student/bulk-update-approval-status";
      var upload = {
        UserInterface: 1,
        Description: this.Description,
        StudentArray: this.recordData,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var successTxt = "";
      var errorTxt = "";
      var flag = 0;
      this.ResultFlag = false;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.LoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);
          successTxt = response.data.success;
          errorTxt = response.data.error;
          console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

          if (flag == 1) {
            thisIns.ResultFlag = true;
            thisIns.sweetAlert("success", output, false);
            thisIns.closePrompt();
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.LoadingFlag = false;
        });
    },
  },
  mounted() {
    this.pageData();
  },
};
</script>

<style scoped>
/* Card & Dialog Outer Styling */
.premium-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 12px 30px rgba(10, 15, 41, 0.15) !important;
  border: 1px solid rgba(58, 103, 177, 0.15) !important;
  background-color: #ffffff !important;
}

/* Header styling */
.premium-dialog-header {
  background: linear-gradient(135deg, #56bda3 0%, #3a67b1 100%) !important;
  padding: 20px 28px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 3px solid #edbe38;
}

.premium-dialog-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(
    circle at 10% 20%,
    rgba(255, 255, 255, 0.05) 0%,
    transparent 60%
  );
  pointer-events: none;
}

.header-content {
  display: flex;
  align-items: center;
}

.premium-dialog-title {
  color: #ffffff !important;
  font-size: 1.3rem;
  font-weight: 750;
  margin: 0;
  letter-spacing: 0.5px;
}

.premium-dialog-subtitle {
  color: rgba(255, 255, 255, 0.8) !important;
  font-size: 0.82rem;
  margin: 4px 0 0 0;
}

.close-btn {
  background-color: rgba(255, 255, 255, 0.08) !important;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  transform: rotate(90deg);
}

/* Content Container */
.premium-dialog-content {
  padding: 28px !important;
  background-color: rgba(10, 15, 41, 0.02) !important;
}

/* Custom Card Container for Sections */
.premium-section-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid rgba(58, 103, 177, 0.15);
  padding: 20px;
  box-shadow: 0 4px 20px rgba(10, 15, 41, 0.02);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.premium-section-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(
      rgba(58, 103, 177, 0.015) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(58, 103, 177, 0.015) 1px, transparent 1px);
  background-size: 20px 20px;
  pointer-events: none;
  opacity: 0.8;
}

.premium-section-card:hover {
  box-shadow: 0 6px 24px rgba(10, 15, 41, 0.05);
  border-color: rgba(58, 103, 177, 0.3);
}

/* Headings within cards */
.section-heading-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  padding-bottom: 12px;
  margin-bottom: 16px;
}

.section-heading-wrapper::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: rgba(65, 64, 66, 0.1);
}

.section-heading-wrapper::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50px;
  height: 2px;
  background: linear-gradient(90deg, #3a67b1 0%, #56bda3 100%);
  z-index: 1;
}

.section-heading-wrapper i {
  background-color: rgba(86, 189, 163, 0.08) !important;
  color: #56bda3 !important;
  padding: 8px !important;
  border-radius: 8px !important;
  font-size: 1.1rem !important;
  margin-right: 10px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.section-title {
  font-size: 0.95rem;
  font-weight: 750;
  color: #0a0f29 !important;
  margin: 0 !important;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.required-field::after {
  content: " *";
  color: #edbe38;
}

/* Selected Student Scroll List */
.student-scroll-list {
  max-height: 260px;
  overflow-y: auto;
  padding-right: 4px;
}

.student-scroll-list::-webkit-scrollbar {
  width: 6px;
}

.student-scroll-list::-webkit-scrollbar-track {
  background: rgba(10, 15, 41, 0.02);
  border-radius: 3px;
}

.student-scroll-list::-webkit-scrollbar-thumb {
  background: rgba(86, 189, 163, 0.3);
  border-radius: 3px;
}

.student-scroll-list::-webkit-scrollbar-thumb:hover {
  background: rgba(86, 189, 163, 0.5);
}

.student-list-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid rgba(10, 15, 41, 0.08);
  margin-bottom: 8px;
  transition: all 0.2s ease;
}

.student-list-item:hover {
  transform: translateX(4px);
  border-color: #0097d7;
  background: rgba(0, 151, 215, 0.02);
}

.student-item-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: rgba(58, 103, 177, 0.06);
  margin-right: 12px;
}

.student-item-info {
  display: flex;
  flex-direction: column;
}

.student-name {
  font-size: 0.88rem;
  font-weight: 600;
  color: #0a0f29;
}

.student-meta {
  font-size: 0.75rem;
  color: #414042;
  margin-top: 2px;
}

.meta-label {
  margin-right: 4px;
}

.meta-value {
  font-weight: 600;
  color: #0a0f29;
}

.no-students-message {
  text-align: center;
  padding: 40px 10px;
}

/* Premium Warning Alert Box */
.premium-alert-banner {
  display: flex;
  align-items: flex-start;
  padding: 14px 18px;
  background-color: rgba(237, 190, 56, 0.1);
  border-left: 4px solid #edbe38;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(237, 190, 56, 0.02);
}

.premium-alert-banner i {
  margin-top: 2px;
}

.alert-banner-text {
  font-size: 0.85rem;
  line-height: 1.5;
  color: #0a0f29;
}

.alert-banner-text strong {
  font-weight: 700;
}

/* Premium Textarea styling */
.premium-textarea ::v-deep .v-input__control {
  border-radius: 8px !important;
}

.premium-textarea ::v-deep .v-input__slot {
  background-color: #ffffff !important;
  border-width: 1px !important;
  transition: all 0.3s ease !important;
}

.premium-textarea ::v-deep .v-input__slot:hover {
  border-color: #0097d7 !important;
}

.premium-textarea ::v-deep .v-input--is-focused .v-input__slot {
  border-color: #3a67b1 !important;
  box-shadow: 0 0 0 3px rgba(58, 103, 177, 0.15) !important;
}

/* Dialog Footer */
.premium-dialog-footer {
  border-top: 1px solid rgba(65, 64, 66, 0.1);
  padding: 20px 0 0 0;
}

.action-buttons-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* Action Buttons */
.action-btn {
  border-radius: 8px !important;
  padding: 10px 20px !important;
  font-size: 0.85rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  height: auto !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.2s ease !important;
}

.action-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;
}

.btn-cancel {
  background-color: #ffffff !important;
  color: #414042 !important;
  border: 1px solid #414042 !important;
  box-shadow: none !important;
}

.btn-cancel:hover {
  background-color: #0a0f29 !important;
  color: #ffffff !important;
  border-color: #0a0f29 !important;
}

.btn-not-eligible {
  background-color: #edbe38 !important;
  color: #0a0f29 !important;
}

.btn-not-eligible:hover {
  background-color: #3a67b1 !important;
  color: #ffffff !important;
}

.btn-not-eligible:disabled {
  background-color: rgba(237, 190, 56, 0.4) !important;
  color: rgba(10, 15, 41, 0.4) !important;
  cursor: not-allowed;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .premium-dialog-header {
    padding: 16px 20px;
  }
  .premium-dialog-content {
    padding: 20px !important;
  }
  .action-buttons-container {
    width: 100%;
    flex-direction: column-reverse;
  }
  .action-btn {
    width: 100%;
    margin: 0 !important;
  }
}
</style>
